// extracted by mini-css-extract-plugin
export default {"icon":"icon--Uje33","spinning":"spinning--_hZsr","spinning2x":"spinning2x--XS5cH"};